// src/pages/NotFoundPage.tsx

import React from 'react';
import logo from '../../../assets/images/agencia_nacional_digital.png';
import style from '../Unauthorized/Unauthorized.module.css';

const NotFoundPage: React.FC = () => {
  return (
    <div className={style.Unauthorized__page}>
      <div className={style.Unauthorized__contianer_img}>
        <img src={logo} alt='Logo' />
      </div>
      <h2>Página no encontrada</h2>
      <p>Lo sentimos, la página que buscas no existe.</p>
    </div>
  );
};

export default NotFoundPage;
